// extracted by mini-css-extract-plugin
export default {"order":"feed-order_order__NZKuc","meta":"feed-order_meta__lMi7z","ingredients":"feed-order_ingredients__Kgi0d","row":"feed-order_row__Pkxo-","preview":"feed-order_preview__RMeuM"};